import React from 'react'
import { styled } from '@mui/material'
import { CheckCircle, Error, Help, Refresh, RemoveCircle } from '@mui/icons-material'
import {
  Button as BaseButton,
  Tooltip as BaseTooltip,
  Popover,
  Typography,
  InfoIcon as BaseInfoIcon
} from '@chilecompra/react-kit/components'

export const AbilityReason = styled(({ reasonKey, ...props }) => <div {...props} />)`
  background-color: ${({ error, theme, reasonKey }) => {
    if (reasonKey === 'DEUDAS LABORALES') return theme.palette.yellow[95]

    if (!error) {
      return theme.palette.custom.red[50.07]
    } else return theme.palette.brand.white
  }};
  border: 1px solid
    ${({ error, theme, reasonKey }) => {
      if (reasonKey === 'DEUDAS LABORALES') return theme.palette.yellow[50]

      if (!error) {
        return theme.palette.red[50]
      } else return theme.palette.custom.gray[75.5]
    }};
  border-radius: 4px;
  display: ${props => props.display};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  margin-top: 8px;
  padding: 16px 24px;
`

export const AbilityReasonContent = styled('div')`
  min-width: 230px;
  max-width: 160px;
`

export const AbilityStatusWrapper = styled('div')`
  align-items: center;
  display: ${props => props.display || 'flex'};
`

export const Content = styled('section')`
  font-size: 14px;
  line-height: 18px;
  overflow-x: auto;
  padding-top: 24px;
  width: 100%;
`

export const Container = styled('div')``

export const DialogContent = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 20px 30px;
`

export const DialogMessage = styled('div')`
  margin: 24px 0 0;
  text-align: center;
  width: 98%;
`

export const ErrorIcon = styled(RemoveCircle)`
  align-self: baseline;
  color: ${props => props.theme.palette.red[50]};
  height: 20px;
  padding: ${props => props.padding};
  transform: rotate(129deg);
  width: auto;
`

export const ExclamationIcon = styled(Error)`
  align-self: baseline;
  color: ${props => props.theme.palette.gray[50]};
  height: 20px;
  padding: ${props => props.padding};
  width: auto;
`

export const HeadingWrapper = styled(({ alignItems, children, ...props }) => <div {...props}>{children}</div>)`
  align-items: ${props => props.alignItems};
  display: flex;
`

export const IconButton = styled(BaseButton)`
  &.MuiButtonBase-root {
    display: contents;
  }
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-size: 14px;
  line-height: 18px;
  padding: ${props => props.padding};
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const Opacity = styled('p')`
  margin: 0;
  opacity: 0.53;
`

export const PopoverTypography = styled(Typography)`
  &.MuiTypography-body1 {
    background: ${props => props.theme.palette.brand.black1};
    color: ${props => props.theme.palette.brand.white};
    border-radius: 3px;
    font-size: 13px;
    max-width: 300px;
    padding: 15px;
  }
`

export const PopoverWithOutPadding = styled(Popover)`
  &.MuiPopover-root .MuiPopover-paper {
    margin: 0;
    padding: 0;
  }
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 32px 0 24px;
  overflow: visible;
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const SuccessIcon = styled(CheckCircle)`
  align-self: baseline;
  color: ${props => props.theme.palette.green[50]};
  height: 20px;
  padding: ${props => props.padding};
  width: auto;
  float: left;
`

export const WarningIcon = styled(CheckCircle)`
  align-self: baseline;
  color: ${props => props.theme.palette.gray[75]};
  height: 20px;
  padding: ${props => props.padding};
  width: auto;
  float: left;
`

export const Tooltip = styled(BaseTooltip)`
  &.MuiTooltip-popper .MuiTooltip-tooltip {
    max-height: 100%;
    max-width: 54ch;

    & > div {
      max-height: 100%;
    }
  }
`

export const TooltipContainer = styled('div')`
  align-items: center;
  padding-bottom: 10px;
`

export const TooltipIcon = styled('span')`
  align-items: center;
  display: flex;
  float: left;
`

export const HelpIcon = styled(Help)`
  &.MuiSvgIcon-root {
    height: 0.6em;
    color: ${props => props.theme.palette.brand.black3};
  }
`

export const DialogIcon = styled('img')`
  width: 64px;
`

export const ContentButtonActualization = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-top: 22px;
`

export const RefreshIcon = styled(Refresh)`
  align-self: baseline;
  color: ${props => props.theme.palette.brand.black3};
  height: 20px;
  padding: 0 0 0 12px;
  width: auto;
`

export const ButtonRecalculate = styled(BaseButton)`
  height: 40px;
  &:hover ${RefreshIcon} {
    color: ${props => props.theme.palette.brand.white};
  }
`

export const ButtonConfirmModal = styled(BaseButton)`
  height: 40px;
`

export const ButtonExitModal = styled(BaseButton)`
  height: 40px;
`
